import { Attr, FieldSchema, isFieldSchema, tableSchemaMap } from '@cumlaude/metadata';
import { ExtraFilterNames } from './filter-name';

export enum BlocklistType {
	GEEN_VO = 'geen_vo',
	GEEN_VSO = 'geen_vso',
	MAGISTER = 'magister',
	SOMTODAY = 'somtoday',
	BESTUUR = 'bestuur',
}

type BlocklistAtt = Attr | ExtraFilterNames;
const blocklists: { type: BlocklistType; atts: BlocklistAtt[] }[] = [];

function updateBlocklist(blocklistType: BlocklistType, column: BlocklistAtt) {
	let blocklist = blocklists.find((blocklist) => blocklist.type === blocklistType);
	if (!blocklist) {
		blocklist = { type: blocklistType, atts: [] };
		blocklists.push(blocklist);
	}

	blocklist.atts.push(column);
}

function buildFromColumn(column: Attr, fieldSchema: FieldSchema) {
	if (fieldSchema.blocklist?.bestuur) updateBlocklist(BlocklistType.BESTUUR, column);
	if (fieldSchema.blocklist?.magister) updateBlocklist(BlocklistType.MAGISTER, column);
	if (fieldSchema.blocklist?.somtoday) updateBlocklist(BlocklistType.SOMTODAY, column);
	if (fieldSchema.blocklist?.geenVO) updateBlocklist(BlocklistType.GEEN_VO, column);
	if (fieldSchema.blocklist?.geenVSO) updateBlocklist(BlocklistType.GEEN_VSO, column);
}

function build() {
	for (const schema of Object.values(tableSchemaMap)) {
		for (const [column, val] of Object.entries(schema.properties)) {
			if (isFieldSchema(val)) {
				buildFromColumn(column as Attr, val);
			}
		}
	}

	updateBlocklist(BlocklistType.BESTUUR, 'x_leerlingselectie');
}

build();

export function blocklistIncludes(blocklistType: BlocklistType, attr: BlocklistAtt): boolean {
	return getBlocklist(blocklistType).includes(attr);
}

function getBlocklist(type: BlocklistType): BlocklistAtt[] {
	return blocklists.find((blocklist) => blocklist.type === type)?.atts ?? [];
}
